import type * as React from 'react';
import { DetailTimeline, EmptyState } from '@redhand/ui';
import { demoTimeline } from '../demo-data.js';
import { PageIntro, StateSection } from '../ui-helpers.js';

export function DetailTimelinePage(): React.JSX.Element {
  return (
    <div>
      <PageIntro title="DetailTimeline" lead="Události entity (objednávka, case, faktura): stavy, e-maily, poznámky. Čas formátuje produkt dle jazyka strany." />
      <StateSection title="Plný stav (stav / e-mail / poznámka)">
        <div className="rh-card">
          <DetailTimeline ariaLabel="Historie případu" items={demoTimeline} />
        </div>
      </StateSection>
      <StateSection title="Prázdný stav">
        <div className="rh-card">
          <DetailTimeline
            ariaLabel="Historie případu"
            items={[]}
            emptyState={<EmptyState title="Zatím žádné události" description="Historie se začne plnit první změnou stavu nebo odeslaným e-mailem." />}
          />
        </div>
      </StateSection>
    </div>
  );
}
